import React from "react";
import AuthManager from "Common/AuthManager";
import ServiceWrapper from "Services/ServiceWrapper";
import AppSettings from "Settings/AppSettings";
import { useEffect, useState } from "react";
import { ERROR, LOADING, SUCCESS } from "../ProductConstants";


type RulesReRunTableDataProps = {
    RuleId: string
    nextItem: string|null
    updateState: Function
}
const RulesReRunTableData = ({ RuleId, nextItem, updateState }: RulesReRunTableDataProps) => {
    let api_base_url = AppSettings.GMS_BACKEND_API_URL;
    const [Loading, setLoading] = useState<{status: string, message?: string}>({
      status: "",
      message: "",
    });
    const handle_commit = async () => {
      setLoading({
        status: "Loading",
        message: "Committing rule",
      });
      let res = await ServiceWrapper.doPost(
        `${api_base_url}rule/publish/${RuleId}`,
        null,
        null,
        AuthManager.getGmsToken()
      );
      if (!res.errorfound) {
        setTimeout(() => {
          check_commit_status(res.data.jobid);
        }, 2000);
      } else {
        setLoading({
          status: "Error",
          message: "Error while commiting Rules",
        });
      }
    };
  
    async function check_commit_status(jobid: string) {
      let ret = await ServiceWrapper.doGet(
        api_base_url + "job/status/" + jobid,
        null,
        null,
        AuthManager.getGmsToken()
      );
  
      if (!ret.errorfound) {
        if (!ret.data.data) {
          setTimeout(() => {
            check_commit_status(jobid);
          }, 2000);
          setLoading({
            status: "Loading",
            message: ret.data.status,
          });
        } else {
          setLoading({
            status: "Success",
            message: "Committed",
          });
          setTimeout(() => {
            setLoading({
              status: "Success",
              message: undefined,
            });
          }, 5000);
  
        }
  
      }
    }
  
 
  
    useEffect(() => {
      handle_commit();
    }, []);
  
    if (Loading.status === SUCCESS) {
      nextItem !== null && updateState(RuleId, SUCCESS, nextItem, LOADING);
      nextItem === null && updateState(RuleId, SUCCESS);
    } else if (Loading.status === ERROR) {
      nextItem !== null && updateState(RuleId, ERROR, nextItem, LOADING);
      nextItem === null && updateState(RuleId, ERROR);
    }
  
    return (
      <>
        {Loading.status === LOADING && (
          <div className="tw-w-10">
            {/* inprogress spinner rotates */}
            <i className="fas fa-spinner tw-text-ink-tertiary tw-animate-spin"></i>
          </div>
        )}
      </>
    );
  };
  

  export default RulesReRunTableData